import { Challenge } from '@wix/ambassador-challenges-v1-challenge/types';

export const isSelfPaced = (challenge: Challenge): boolean =>
  Boolean(challenge?.settings?.timelineType?.selfPaced);

export const getSectionNumberInProgram = (challenge: Challenge): number => {
  return challenge?.stepsSummary?.sectionsNumber || 0;
};
